import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

type InitVarContext<T> = {
  crmInitVar: T | null;
};

@Directive({
  selector: '[crmInitVar]',
})
export class InitVarDirective<T> implements OnInit {
  private context: InitVarContext<T> = { crmInitVar: null };

  constructor(private viewContainer: ViewContainerRef, private templateRef: TemplateRef<InitVarContext<T>>) {}

  // eslint-disable-next-line sky/restrict-getter-setter
  @Input()
  set crmInitVar(value: T) {
    this.context.crmInitVar = value;
  }

  ngOnInit(): void {
    this.viewContainer.createEmbeddedView(this.templateRef, this.context);
  }
}
